/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

function processSummaryData(addTo, values) {
  const configs = {}
  values.forEach(data => {
    const { location, config, summary } = data
    configs[config] = 0
    addTo.locations[location].summaries[config] = summary
  })

  addTo.allConfigs = Object.keys(configs).sort()
  return addTo
}

export default processSummaryData
